import React, { useState, useEffect, useContext } from "react";
import ArrowButton from "../../atoms/arrow-button/arrowButton";
import SeccionTitle from "../../atoms/seccion-title/seccionTitle";
import AlertSection from "../../atoms/alert-section/alertSection";
import { getAllCategories } from "../../../services/scheduling";
import "./categoryOrganism.scss";
import Loading from "../../atoms/loading/loading";
import ButtonSchedule from "../../atoms/button-schedule/button-schedule";
import GlobalContext from "../../../contexts/globalContext";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { openNotification } from "../../../utils/OpenNotification";

interface categoryOrganismInterface {
  setpageAtive: any;
  setselectCategory: any;
  setnameCategory: any;
  COMPANYID: any;
  content: any;
  afterPage: string;
}
const imageBanner = require("../../../assets/images/BannerOpaco.png");
const categoryOrganism = (props: categoryOrganismInterface) => {
  const {
    setpageAtive,
    setselectCategory,
    setnameCategory,
    content,
    afterPage,
  } = props;
  const [buttonActive, setbuttonActive] = useState("");
  const [isServiceSelected, setIsServiceSelected] = useState(false);
  const [dataCategories, setdataCategories] = useState<any>([]);
  const [dataCategoriesOrd, setdataCategoriesOrd] = useState<any>([]);
  const [loading, setloading] = useState(false);
  const [hooverActive, setHooverActive] = useState(false);
  const contextValue = useContext(GlobalContext);

  const setActiveButton = (name) => {
    setbuttonActive(name);
  };

  const handleSelectCategory = () => {
    if (buttonActive !== "") {
      let data = dataCategories.find(
        (element) => element.name === buttonActive
      );
      setselectCategory(data);
      setpageAtive(2);
      setnameCategory(buttonActive);
    }
  };
  const organizationVector = (data) => {
    const objMapped = data.reduce((acc, item) => {
      (acc[item.categoryId] = acc[item.categoryId] || []).push(item);
      return acc;
    }, {});
    setdataCategoriesOrd(Object.values(objMapped));
  };
  useEffect(() => {
    setloading(true);
    getAllCategories(contextValue.userInfoContext.data?.userJwt).then((res) => {
      if (res) {
        let isServiceSelected = false;
        let defaultService = "";
        setdataCategories(res.data.data.transServiceList);
        organizationVector(res.data.data.transServiceList);
        // read value from local storage and init active button
        res.data.data.transServiceList.map((service) => {
          if (service.id === "5fe25114e36db435fb7d9806") {
            defaultService = service.name;
          }

          if (service.id === localStorage.getItem("selected-service-id")) {
            setActiveButton(service.name);
            isServiceSelected = true;
            handleSelectCategory();
          }
        });
        if (!isServiceSelected) {
          setActiveButton(defaultService);
        }
        setIsServiceSelected(isServiceSelected);
      }
      setloading(false);
    });
  }, []);

  useEffect(() => {
    if (dataCategoriesOrd.length != 0) {
      dataCategories.map((ele) => {
        if (
          ele.name === buttonActive &&
          ele.id === "5fe25114e36db435fb7d9806"
        ) {
          openNotification(
            "warning",
            "Información",
            "Si eres afiliado y tu tarifa es A o B este servicio es sin costo para ti."
          );
        } else if (
          ele.name === buttonActive &&
          ele.id === "5fe25bd0e36db435fb7d9841"
        ) {
          openNotification(
            "warning",
            "Información",
            "Si eres afiliado y tu tarifa es A o B este servicio es sin costo para ti"
          );
        } else if (
          ele.name === buttonActive &&
          ele.id === "5fe25c054b731136d24390bb"
        ) {
          openNotification(
            "warning",
            "Información",
            "Si eres afiliado y tu tarifa es A o B este servicio es sin costo para ti"
          );
        } else if (
          ele.name === buttonActive &&
          ele.id === "5fe25c33e36db435fb7d9843"
        ) {
          openNotification(
            "warning",
            "Información",
            "Si eres afiliado y tu tarifa es A o B este servicio es sin costo para ti"
          );
        } else if (
          ele.name === buttonActive &&
          ele.id === "6000ba72beea2407f8cd1999"
        ) {
          openNotification(
            "warning",
            "Información",
            "Si eres afiliado y tu tarifa es A o B este servicio es sin costo para ti"
          );
        }
      });
    }
  }, [buttonActive]);

  useEffect(() => {
    if (isServiceSelected) {
      handleSelectCategory();
    }
  }, [isServiceSelected]);

  return (
    <>
      <img
        className="hide-on-mobile imagen-banner"
        src={imageBanner}
        alt="Banner Opaco Red Amor"
      />
      <div className="o-category">
        <div className="o-category__content__left">
          <SeccionTitle
            title={content.tituloBanner}
            description={content.tituloDescripcion}
          />
          <div className="a-seccionTitle-requirements">
            {documentToReactComponents(JSON.parse(content?.descripcion?.raw))}
            {documentToReactComponents(JSON.parse(content?.descripcion?.raw))}
          </div>
          <AlertSection
            alert={JSON.parse(content.descripcion.raw).content[2]}
          />
        </div>
        <div className="o-category__content">
          <div
            className={`o-category__content__right `}
            onMouseOver={() => setHooverActive(true)}
            onMouseLeave={() => setHooverActive(false)}
          >
            {loading && <Loading />}
            {dataCategoriesOrd &&
              dataCategoriesOrd.map((category, index) => {
                return (
                  <div key={index}>
                    <h3 className={`o-category__content__text `}>
                      {category[0].categoryName}
                    </h3>
                    <div className="o-category__content__interna">
                      {category.map((subcategory, i) => {
                        return (
                          <ButtonSchedule
                            key={`btnCategory${i}`}
                            name={subcategory.name}
                            active={buttonActive === subcategory.name}
                            setbuttonActive={setActiveButton}
                            gtm={`gtmRedDeAmorSesionIniciadaAgendarServicioCategoria${normalizeTwoWords(
                              "Asesoría psicológica"
                            )}${normalizeTwoWords(subcategory.name)}`}
                          />
                        );
                      })}
                    </div>
                  </div>
                );
              })}

            {!loading && dataCategories.length < 1 && (
              <p>No se encontro categorias</p>
            )}
          </div>
          <div className="tooltip">
            <span
              className={`tooltiptext ${
                hooverActive === true && buttonActive === ""
                  ? "tooltip-active"
                  : ""
              }`}
            >
              *Recuerda que debes seleccionar un servicio para poder continuar
            </span>
          </div>
        </div>
      </div>
      <div className="o-category__footer">
        <ArrowButton
          text={afterPage}
          way={"right"}
          gtmMark={
            "gtmRedDeAmorSesionIniciadaAgendarServicioCategoriaSiguienteEspecialista"
          }
          onAction={() => handleSelectCategory()}
        />
      </div>
    </>
  );
};

export default categoryOrganism;
